export default __webpack_public_path__ + "static/color-analysis-veins-074ddeacbffcce721591497226705131.jpg";